<template>
  <base-campaign-targeting-rule>
    <div>When a visitor has been on the page for at least {{ data / 1000 }} seconds.</div>
  </base-campaign-targeting-rule>
</template>

<script>
import BaseCampaignTargetingRule from "@/components/campaign-targeting-rules/BaseCampaignTargetingRule"
import targetingRuleMixin from "@/mixins/targeting-rule-mixin"
import targetingRuleNames from "@/components/campaign-targeting-rules/targetingRuleNames"

const mixin = targetingRuleMixin("when", targetingRuleNames.whenRules.afterMilliseconds)

export default {
  name: "TargetingAfterMilliseconds",
  components: { BaseCampaignTargetingRule },
  mixins: [mixin]
}
</script>
